import React, { useState } from "react";
import { Modal, Tabs, Tag } from "antd";
// import { Tag } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { getRegionValue } from "../../API/api";
import { isObjectDefinedAndNotNull } from "./RestrictPermission";

const { TabPane } = Tabs;
function ConfigModal({
  open,
  setOpen,
  handleOpen,
  handleClose,
  setRegionName,
}) {
  const state = useSelector((state) => state?.restrictPermission);
  const dispatch = useDispatch();
  const {
    selectRegionAction,
    SelectedCountryValueAction,
    CountryActionBoolean,
  } = bindActionCreators(Actions, dispatch);
  const { geoLevelId, geoLevelValue, domainId, check } = useSelector(
    (state) => {
      return {
        geoLevelId: state.cmRoot.selecetdRoutingValue,
        geoLevelValue: state.cmRoot?.selectedGeoLevel?.name,
        domainId: state.cmRoot?.selectedDomainIds,
        length: state.cmRoot?.selectedDomainsObj?.length,
        check: state.cmRoot.selecetdRoutingValue,
      };
    }
  );
  // console.log(geoLevelId, geoLevelValue);
  const [countryId, setCountryId] = useState("1");
  const [value, setValue] = useState("1");
  const [regionVal, setRegionVal] = useState(null);
  const selectRegion = (item) => {
    let val = {
      label: item,
      name: item,
      value: item,
    };
    selectRegionAction(val);
    setOpen(false);
  };
  const selectCountry = (item) => {
    CountryActionBoolean(true);
    let val = {
      label: item,
      name: item,
      value: item,
    };
    let val1;
    getRegionValue(item, countryId).then((res) => {
      val1 = res?.map((item) => {
        // console.log("item", item);
        return {
          label: item.value,
          name: item.value,
          value: item.value,
        };
      });
      val1 !== undefined && selectRegionAction(val1[0]);
    });
    // console.log("first", state?.SelectedRegionValue);

    SelectedCountryValueAction(val);
    setOpen(false);
  };
  const onChange = (key) => {
    setValue(key);
  };
  return (
    <div>
      <Modal
        title={
          <div style={{ textAlign: "center", width: "100%" }}>
            {" "}
            Existing Configuration
          </div>
        }
        open={open}
        onOk={handleClose}
        onCancel={handleClose}
        footer={null}
      >
        <Tabs defaultActiveKey="1" activeKey={value} onChange={onChange}>
          <TabPane
            tab="Region
          "
            key="1"
          >
            {isObjectDefinedAndNotNull(state?.restrictionValues["2"]) &&
              Object.keys(state?.restrictionValues["2"])?.map((item, index) => (
                <>
                  {" "}
                  <Tag
                    style={{ marginTop: "10px", cursor: "pointer" }}
                    onClick={() => selectRegion(item)}
                  >
                    {item}
                  </Tag>
                </>
              ))}{" "}
          </TabPane>
          <TabPane tab="Country" key="2">
            {isObjectDefinedAndNotNull(state?.restrictionValues["1"]) &&
              Object.keys(state?.restrictionValues["1"])?.map(
                (country, index) => (
                  <>
                    {" "}
                    <Tag
                      style={{ marginTop: "10px", cursor: "pointer" }}
                      onClick={() => selectCountry(country)}
                    >
                      {country}
                    </Tag>
                  </>
                )
              )}{" "}
          </TabPane>
        </Tabs>
      </Modal>
    </div>
  );
}

export default ConfigModal;
